export enum ResetOperatingHours {
  CONTROLLER_MODEL = 'controllermodel_1000',
}
